module.exports = __webpack_public_path__ + "img/9.d2ea10b0.png";